export const normalizeVersion = (version?: string | null) => {
  const trimmed = version?.trim()
  return trimmed || undefined
}

export const isUpdateAvailable = (
  current?: string | null,
  latest?: string | null
) => {
  const currentVersion = normalizeVersion(current)
  const latestVersion = normalizeVersion(latest)

  if (!currentVersion || !latestVersion) {
    return false
  }

  return currentVersion !== latestVersion
}
